import axiosAuth from "./axiosAuth";
import {tokenStorage} from "../app/tokenStorage";

import {
    LOGIN,
    ACCESS_CODE,
    TOKEN_REFRESH,
    LOGOUT,
    CHECK_EMAIL,
    LOGIN_EXTERNAL,
} from "./routes/auth_routes";


export function loginApi(data) {
    return axiosAuth.post(LOGIN, data);
}

export function checkAccessCodeApi(data) {
    return axiosAuth.post(ACCESS_CODE, data);
}

export function checkEmailApi(email) {
    return axiosAuth.get(CHECK_EMAIL(email));
}

export function loginExternalApi(data) {
    return axiosAuth.post(LOGIN_EXTERNAL, data);
}

export function signOutApi() {
    return axiosAuth.get(LOGOUT, {
        headers: {
            "Authorization": `Bearer ${tokenStorage.getToken()}`,
            "Session-unique": `${tokenStorage.getSessionId()}`
        }
    });
}
